import type { SVGProps } from 'react';

export const Folder = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.3 19.5c-.5 0-.925-.175-1.275-.525A1.736 1.736 0 0 1 2.5 17.7V6.3c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525h4.75c.233 0 .458.05.675.15.233.083.433.208.6.375L11.8 6.5h7.9c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v9.4c0 .5-.175.925-.525 1.275-.35.35-.775.525-1.275.525H4.3Zm0-1.5h15.4a.27.27 0 0 0 .2-.075.31.31 0 0 0 .1-.225V8.3a.238.238 0 0 0-.1-.2.238.238 0 0 0-.2-.1h-8.525l-1.9-1.925-.1-.05A.278.278 0 0 0 9.05 6H4.3a.31.31 0 0 0-.225.1.27.27 0 0 0-.075.2v11.4c0 .083.025.158.075.225.067.05.142.075.225.075ZM4 18V6v12Z" />
    </svg>
  );
};
